import * as Yup from "yup";

export const formInitialValues = {
  Plant_Type: "",
  Plot_Auto_ID: "",
  Plant_Auto_ID: "",
  Total_Plant_Monitoring_Count: "",
  Total_Plant_Count: "",
  Loc_Auto_ID: "",
  Loc_Autocomplete_Name: "",
  Plot_Autocomplete_Name: "",
  // new changes - tag v3.0.1
  Aspect: "",
  Soil_Texture: "",
  /* new changes - tag v3.0.3 */
  Plant_Autocomplete_Name: "",
};

export const formValidationSchema = Yup.object().shape({
  Loc_Autocomplete_Name: Yup.string().required("Location Name is required"),
  Plant_Type: Yup.string().required("Plantation type is required"),
  Plot_Autocomplete_Name: Yup.string().required("Plotting name is required"),
  Plant_Autocomplete_Name: Yup.string().required("Plant name is required"),
  Total_Plant_Monitoring_Count: Yup.number()
    .integer("Plant Monitoring Count should not be in decimal")
    .typeError("Plant Monitoring Count must be a number")
    .required("Plant Monitoring Count is required")
    .min(1, "Plant Monitoring Count must be greater than or equal to 1")
    .max(99999, "Plant Monitoring Count must be less than or equal to 99999"),
  Total_Plant_Count: Yup.number()
    .integer("Total Planting Count should not be in decimal")
    .typeError("Total Planting Count must be a number")
    .required("Total Planting Count is required")
    .min(1, "Total Planting Count must be greater than or equal to 1")
    .max(99999, "Total Planting Count must be less than or equal to 99999"),
  // Changes tag - v3.0.1
  Aspect: Yup.string().required("Aspect is required field!"),
  Soil_Texture: Yup.string().required("Soil Texture is required field!"),
});
